import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ba88aab"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "practice-scenario-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "实践场景", -1));
const _hoisted_3 = {
  class: "scene-classification"
};
const _hoisted_4 = ["onMousemove"];
const _hoisted_5 = {
  key: 0,
  class: "imgLight",
  alt: ""
};
const _hoisted_6 = {
  key: 1,
  class: "imgDark",
  alt: ""
};
const _hoisted_7 = {
  class: "scene-con"
};
const _hoisted_8 = {
  class: "text-title"
};
const _hoisted_9 = {
  key: 0,
  class: "text-content"
};
const _hoisted_10 = {
  class: "text-detail"
};
const _hoisted_11 = {
  key: 0,
  class: "img-con",
  alt: ""
};
const _hoisted_12 = {
  key: 1,
  class: "model-control"
};
import { ref } from 'vue';
import ButtomCom from '@/components/buttomCom.vue';
import agentManage from '@/module/codeProduct/components/agentManage.vue';
import ProductInfo from '@/module/codeProduct/components/protocolCom.vue';
export default {
  __name: 'practiceScenarioCom',
  props: {
    menu: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    dataGroup: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    isSlots: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    let activeScene = ref(0);
    const changeScene = val => {
      activeScene.value = val;
    };
    const jumpPage = url => {
      // 获取当前页面地址
      url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      window.open(url);
    };
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(__props.isSlots ? 'page-high' : 'page-low')
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(_unref(activeScene) === index ? 'scene-title-active scene-title pr' : 'scene-title pr'),
          onMousemove: $event => changeScene(index)
        }, [item?.lightIcon ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_5, null, 512)), [[_directive_lazy, item?.lightIcon]]) : _createCommentVNode("", true), item?.darkIcon ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_6, null, 512)), [[_directive_lazy, item?.darkIcon]]) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)], 42, _hoisted_4);
      }), 128))]), _createElementVNode("div", {
        class: _normalizeClass(__props.isSlots ? 'scene-high padding-high' : 'scene-low padding-low')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataGroup, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(_unref(activeScene) === index ? 'scene-content text-fadeIn' : 'scene-content text-fadeOut')
        }, [_createElementVNode("div", {
          class: _normalizeClass(__props.isSlots ? 'text-con-high text-con' : 'text-con-low text-con')
        }, [_createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1), item.content ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.content), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_10, _toDisplayString(item.detail), 1), _createVNode(ButtomCom, {
          class: "buttom-box",
          "btn-name": '免费试用',
          "is-more": false,
          "is-arrow": true,
          onClick: _cache[0] || (_cache[0] = $event => jumpPage('/bookDemoPage.html'))
        })], 2), !__props.isSlots ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_11, null, 512)), [[_directive_lazy, item?.backIcon]]) : (_openBlock(), _createElementBlock("div", _hoisted_12, [index === 0 ? (_openBlock(), _createBlock(agentManage, {
          key: 0,
          class: "model-box"
        })) : _createCommentVNode("", true), index === 1 ? (_openBlock(), _createBlock(ProductInfo, {
          key: 1,
          class: "model-agent"
        })) : _createCommentVNode("", true)]))], 2);
      }), 128))], 2)])], 2);
    };
  }
};